/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br."Knowledge
 * for Decisions (K4D)" and the slogan"Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/**
 * Underlined navigation primitives used by GlobalHeader. Hover state is owned
 * by the parent and passed in so a single hover target is shared across items.
 */

import { Link } from'react-router';
import { cn } from'@/shared/ui/utils/tailwind';
import { Text, UnstyledButton } from'@/shared/ui';

const BASE ='relative text-sm font-(--font-regular) py-(--space-2) px-0 transition-colors duration-200';
const ACTIVE ='text-(--seed-base)';
const INACTIVE ='text-(--text-secondary) hover:text-(--seed-base):text-(--brand-accent)';
const UNDERLINE =
  'absolute bottom-0 left-0 h-px bg-(--seed-base) transition-all duration-300 ease-out';

interface HoverProps {
  hoveredNav: string | null;
  setHoveredNav: (id: string | null) => void;
}

interface NavButtonProps extends HoverProps {
  id: string;
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export const NavButton: React.FC<NavButtonProps> = ({
  id,
  label,
  isActive,
  onClick,
  hoveredNav,
  setHoveredNav,
}) => (
  <UnstyledButton
    onMouseEnter={() => setHoveredNav(id)}
    onMouseLeave={() => setHoveredNav(null)}
    onClick={onClick}
    className={cn(BASE,'bg-transparent border-none cursor-pointer', isActive ? ACTIVE : INACTIVE)}
  >
    {label}
    <Text component="span" className={UNDERLINE} style={{ width: hoveredNav === id || isActive ?'100%' :'0%', visibility: hoveredNav === id || isActive ?'visible' :'hidden' }} />
  </UnstyledButton>
);

interface NavLinkProps extends HoverProps {
  id: string;
  label: string;
  to: string;
  isActive: boolean;
}

export const NavLink: React.FC<NavLinkProps> = ({
  id,
  label,
  to,
  isActive,
  hoveredNav,
  setHoveredNav,
}) => (
  <Link
    to={to}
    onMouseEnter={() => setHoveredNav(id)}
    onMouseLeave={() => setHoveredNav(null)}
    className={cn(BASE,'no-underline', isActive ? ACTIVE : INACTIVE)}
  >
    {label}
    <Text component="span" className={UNDERLINE} style={{ width: hoveredNav === id || isActive ?'100%' :'0%', visibility: hoveredNav === id || isActive ?'visible' :'hidden' }} />
  </Link>
);
